import { ModalThin, ModalThinButtonsBar } from '@/component/Modal';

export function ModalForm(props) {
  const { onClose, children, buttons } = props;
  return (
    <ModalThin onClose={onClose}>
      <div className="flex flex-col flex-nowrap justify-between h-full flex-1 md:min-h-[200px]">
        <div className="mx-4 mt-6 flex flex-col grow">{children}</div>
        <ModalThinButtonsBar>{buttons}</ModalThinButtonsBar>
      </div>
    </ModalThin>
  );
}
